export default function (context, value) {
    context.commit('set', {
        tab: value,
    });
}